export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-8 text-center mt-12">
      2026 DNAtabase.eu | Developed by MDxCore, Rigshospitalet
    </footer>
  );
}